<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <h6>Ревизии</h6>
      </div>
      <div class="card-body">

        <div class="text-center">
          <pulse-loader :loading="revisionsLoading" :color="loadingColor"/>
        </div>

        <div v-if="!revisionsLoading">
          <table v-if="revisions" ref="recordsTable" class="table table-sm table-hover">
            <thead>
            <tr>
              <th></th>
              <th>ID</th>
              <th>Дата ревизии</th>
              <th>Дата выполнения</th>
              <th>Комментарий</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(record, index) in revisions" class="pointer" @click="() => {selectedRevision = record.id}">
              <td>
                {{index + 1}} <input v-model="selectedRevision" name="selectedRevision" :value="record.id" type="radio">
              </td>
              <td>{{record.id}}</td>
              <td>{{record.date}}</td>
              <td>{{record.updated_at}}</td>
              <td></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="card" v-if="revisions && revisions.length">
      <div class="card-header">
        <h6>Поиск по ревизии</h6>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <drugSearch ref="drugSearch" :drugSelected="drugSelected" :detailedSearch="true"/>
          </div>
          <div class="col-md-6">
            <vue-ladda @click="search()" button-class="btn btn-info"
                       data-style="zoom-in"
                       :loading="drugLoading">Поиск
            </vue-ladda>
          </div>
        </div>

        <div class="text-center m-t-20">
          <pulse-loader :loading="drugLoading" :color="loadingColor"/>
        </div>

        <div v-if="drugData && drugData.length" class="m-t-20">
          <table class="table table-sm table-hover">
            <thead>
            <tr>
              <th></th>
              <th>Препарат</th>
              <th>Наличие</th>
              <th>Себестоимость (Euro)</th>
              <th>Инвойс</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(revData, index) in drugData">
              <td>{{index+1}}</td>
              <td>{{revData.drug_data ? revData.drug_data.prep : selectedDrug.prep}}</td>
              <td>{{revData.in_store}}</td>
              <td>{{revData.cost_price}}</td>
              <td>{{revData.last_invoice_id}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
  import api from '@/api'
  import drugSearch from '@/components/drugs/drugSearch'
  import VueLadda from 'vue-ladda/src/vue-ladda.vue'

  export default {
    components: {
      drugSearch,
      VueLadda,
    },
    data() {
      return {
        loadingColor: '#007dcc',
        revisionsLoading: false,
        drugLoading: false,
        revisions: null,
        drugData: [],
        searchDrug: null,
        selectedDrug: null,
        selectedRevision: null,
      }
    },
    mounted() {
      this.getRecords()
    },
    watch: {
      selectedRevision() {
        this.drugData = [];
      }
    },
    methods: {
      async search(drug = null) {
        if (!drug) {
          drug = this.selectedDrug;
        }
        if (!drug) return;

        this.drugData = [];
        this.drugLoading = true;
        const {data} = await api.index('/nomenclature/revisions/getDrugInfo?id=' + drug.id + '&title=' + drug.title + '&revision=' + this.selectedRevision)
        if (!data.success) {
          this.Toast.fire({
            type: 'warning',
            title: data.message || 'Ошибка загрузки данных препарата'
          })
        } else {
          if (drug.id) {
            this.drugData.push(data.revData);
          } else {
            this.drugData = data.revData;
          }
        }
        this.drugLoading = false;
      },
      async drugSelected(drug) {
        this.selectedDrug = drug;
        if (this.selectedDrug) {
          await this.search(drug);
        }
      },
      async getRecords(page = null) {
        this.revisions = null;
        this.revisionsLoading = true;
        // this.$refs.recordsTable.clearCheckboxes();
        const {data} = await api.index('/nomenclature/revisions?page=' + page)

        if (!data.success) {
          this.Toast.fire({
            type: 'warning',
            title: 'Ошибка загрузки ревизий'
          })
          this.revisionsLoading = false;
          return;
        }

        const {data: list, ...pagination} = data.records;
        this.revisions = list;
        this.selectedRevision = this.revisions[0].id;
        this.revisionsLoading = false;
      },
    }
  }

</script>
